import {
    URL_CITRUSGPT_ABRIR_CHAT,
    URL_CITRUSGPT_BUSCAR_CONVERSACIONES,
    URL_CITRUSGPT_INICIAR_CHAT,
    URL_CITRUSGPT_NUEVA_CONVERSACION,
    URL_CITRUSGPT_PREGUNTAR
} from "../Utils/constant.js";

import { buscar } from "../../../Commons/Scripts/Utils/Buscar";

/** La conversación activa con su historial, los chats recientes y los permisos. */
export const iniciarChat = () => buscar(URL_CITRUSGPT_INICIAR_CHAT, {});

/** Carga un chat anterior del listado de recientes. */
export const abrirChat = (id) => buscar(URL_CITRUSGPT_ABRIR_CHAT, { id });

/** Cierra las conversaciones abiertas y arranca una nueva. */
export const nuevaConversacion = () => buscar(URL_CITRUSGPT_NUEVA_CONVERSACION, {});

/** Una página del historial, de la conversación más reciente a la más vieja. */
export const buscarConversaciones = (pagina) =>
    buscar(URL_CITRUSGPT_BUSCAR_CONVERSACIONES, { pagina: pagina || 0 });

/** Manda una pregunta y devuelve el historial ya actualizado. */
export const preguntar = (conversacionId, pregunta) =>
    buscar(URL_CITRUSGPT_PREGUNTAR, { conversacionId, pregunta });

const nativeUrl = "/Seguridad/WebService/AsistenteWebService.asmx/";
// A local observation deadline never proves the provider stopped processing.
// The caller retains the GUID and can only recover, never resend automatically.
const nativeRequest = (method, body) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject({
        Mensaje: "Terminó la espera local. La consulta y su identificador se conservan; no vuelva a enviarla.",
        Interno: true, Tipo: "Error", ConsumoIncierto: true
    }), 390000);
    buscar(nativeUrl + method, body, {
        procesarError: () => ({
            Mensaje: "Se interrumpió la comunicación. La consulta y su identificador se conservan; no vuelva a enviarla.",
            Interno: true, Tipo: "Error", ConsumoIncierto: true
        })
    }).then(resolve, reject).finally(() => clearTimeout(timer));
});

export const preguntarNative = (conversacionId, pregunta, requestId) =>
    nativeRequest("PreguntarNative", { conversacionId, pregunta, requestId });
export const recuperarNative = (conversacionId, requestId) =>
    nativeRequest("RecuperarNative", { conversacionId, requestId });
export const historialNative = (conversacionId) =>
    nativeRequest("HistorialNative", { conversacionId });

/** User observations are local review notes; they never generate or approve an answer. */
export const guardarObservacionNative = (conversacionId, requestId, observacion, feedbackId) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject({
        Mensaje: "No se confirmó el registro de la observación. Conserve el texto y revise antes de enviarlo nuevamente.",
        Interno: true, Tipo: "Error", ObservacionNoConfirmada: true
    }), 30000);
    buscar(nativeUrl + "GuardarObservacionNative", { conversacionId, requestId, observacion, feedbackId }, {
        procesarError: () => ({
            Mensaje: "No se confirmó el registro de la observación. Su respuesta permanece disponible.",
            Interno: true, Tipo: "Error", ObservacionNoConfirmada: true
        })
    }).then(resolve, reject).finally(() => clearTimeout(timer));
});
